import { GradientDots, Legend } from '@statsbomb/kitbag-datavis';
import { useRef } from 'react';

const DATA_PILL_GRADIENT_LEGEND_LABELS = ['0', '25', '50', '75', '100'];

export const DataPillGradientLegend = ({ title, resultsCount }: { title: string; resultsCount?: number }) => {
  const ref = useRef<HTMLLegendElement>(null);
  const labelValues = resultsCount ? [resultsCount.toString(), '1'] : DATA_PILL_GRADIENT_LEGEND_LABELS;

  return (
    <Legend legendRef={ref}>
      <GradientDots labelValues={labelValues} title={title} gradientName="valued" />
    </Legend>
  );
};
